import { CargoDropDown } from "../../../../../../common/domain/models/cargo_dropdown";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DefaultFornecedor } from "../../../../../../common/components/default_fornecedor_select";
import { DefaultContrato } from "../../../../../../common/components/default_contratos_select";

/**
 * Header
 */

type Props = {
  selectedIdCargos: number[] | null,
  cargos: CargoDropDown[],
  selectedIdCentroCustos: number[] | null,
  centroCustos: CentroCustoDropDown[],
  FornecedorPesquisa: number;
  onSelectedCargoChange: (cargos: number[] | null) => void,
  onSelectedCentroCustoChange: (centroCustos: number[] | null) => void,
  onClearFilters: () => void,
  handleFornecedorChange: (v: number) => void;
};

export const Header = ({
  selectedIdCargos,
  cargos,
  selectedIdCentroCustos,
  centroCustos,
  FornecedorPesquisa,
  handleFornecedorChange,
  onSelectedCargoChange,
  onSelectedCentroCustoChange,
  onClearFilters,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-2 grid-flow-row-dense ">
            <DefaultMultiAutocomplete
              label='Cargo'
              value={cargos.filter(x => selectedIdCargos?.includes(x.idCargo))}
              options={cargos}
              getOptionLabel={x => x.descricao}
              getOptionKey={x => x.idCargo}
              onChange={x => onSelectedCargoChange(x?.map(y => y.idCargo) ?? null)} />

            <DefaultMultiAutocomplete
              label='Centro de Custo'
              value={centroCustos.filter(x => selectedIdCentroCustos?.includes(x.id))}
              options={centroCustos}
              getOptionLabel={x => x.title}
              getOptionKey={x => x.id}
              onChange={x => onSelectedCentroCustoChange(x?.map(y => y.id) ?? null)} />

          </div>
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-2 grid-flow-row-dense ">
            <DefaultFornecedor
              key={`forn-${FornecedorPesquisa}`}
              name="PesquisarFornecedor"
              value={FornecedorPesquisa || null}
              onChange={(valor) => handleFornecedorChange(Number(valor))}
              label="Fornecedor"
            />
          </div>
          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}